import { useRoutes } from 'react-router-dom';
import { publicRoutes } from './public';
import { Business } from '@/features/availability/types';
import React from 'react';
type ContextType = {
  business:Business
};

export const UserContext = React.createContext<ContextType | undefined>(undefined);
export const AppRoutes = () => {
  const element = useRoutes(publicRoutes);

  return <>{element}</>;
};
